package co.maytes.standupbot.dashboard.lib.auth

import kotlinx.browser.window
import kotlinx.coroutines.CompletableDeferred
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.promise
import org.w3c.dom.MessageEvent

object CrossTabAuth {
    private const val CHANNEL = "sb-auth"
    private const val SIGNED_OUT = "signed-out"
    private const val REFRESH_LOCK = "sb-auth-refresh"

    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
    private val channel: dynamic = openChannel()

    private fun openChannel(): dynamic =
        try {
            val ctor = window.asDynamic().BroadcastChannel
            val name = CHANNEL
            if (ctor == undefined) null else js("new ctor(name)")
        } catch (t: Throwable) {
            null
        }

    fun announceSignedOut() {
        runCatching { channel?.postMessage(SIGNED_OUT) }
    }

    fun onSignedOut(listener: () -> Unit) {
        val target = channel ?: return
        target.onmessage = { event: MessageEvent -> if (event.data == SIGNED_OUT) listener() }
    }

    suspend fun <T> withRefreshLock(block: suspend () -> T): T {
        val locks = window.navigator.asDynamic().locks
        if (locks == undefined || locks == null) return block()
        val outcome = CompletableDeferred<Result<T>>()
        val holder: (dynamic) -> dynamic = {
            scope.promise {
                outcome.complete(runCatching { block() })
                Unit
            }
        }
        locks.request(REFRESH_LOCK, holder)
        return outcome.await().getOrThrow()
    }
}
